<div class="settings-page-wrapper">
  <div class="settings-page-container">
    <div class="header">
      Settings
    </div>

    <div class="settings">
      <!-- Locations -->
      <app-inventory-locations-setting></app-inventory-locations-setting>
      <!-- Compounding -->
     <app-compounding></app-compounding>
      <!-- C3 - C5 -->
      <app-enable-c3-c5-setting></app-enable-c3-c5-setting>
      <!-- Back Count -->
      <app-back-count></app-back-count>
      <!-- Wholesaler Order Integration -->
      <div class="settings-item wholesaler-integration" *ngIf="isNotBasicPlan">
        <div class="heading-wrapper">
          <div class="description">
            <div class="settings-header">
              <img *ngIf="currentWholesalerIntegrationStatus === WholesalerIntegrationStatusEnum.Created"
                  src="assets/icons/icon-alert-success-blue.svg" alt="success-icon" class="icon-created"
              />
              <img *ngIf="currentWholesalerIntegrationStatus === WholesalerIntegrationStatusEnum.Invalid"
                  src="assets/icons/icon-danger-red.svg" alt="success-icon" class="icon-error"
              />
              <div>
                Wholesaler Order Integration
              </div>
            </div>
            <div *ngIf="currentWholesalerIntegrationStatus === WholesalerIntegrationStatusEnum.Initial"
                class="settings-sub-header"
            >
              Connect directly to your wholesaler to automatically receive your orders.
            </div>
            <div *ngIf="currentWholesalerIntegrationStatus === WholesalerIntegrationStatusEnum.Created"
                class="settings-sub-header"
            >
              Your wholesaler orders have successfully synced.
            </div>
            <div *ngIf="currentWholesalerIntegrationStatus === WholesalerIntegrationStatusEnum.Invalid"
                class="settings-sub-header"
            >
              There was a problem connecting to your EDI file.
            </div>
          </div>
          <div class="controls">
            <app-button styleClass="settings"
                        subStyle="blue"
                        [minWidth]="0"
                        (clicked)="openWholesalerIntegrationDialog()"
            >
              {{(wholesalerIntegrations$ | async)?.length > 0 ? 'Add New' : 'Add Wholesaler'}}
            </app-button>
          </div>
        </div>

        <div *ngIf="(wholesalerIntegrations$ | async)?.length && showWholesalerList" class="list-wrapper">
          <app-tabs (tabSelected)="tabWIChanged($event)" [tabsMarginLeft]="'32px'">
            <app-tab [tabValue]="WholesalerIntegrationActivityEnum.Active"
                    [count]="wholesalerIntegrationActiveList?.length"
                    [tabTitle]="'Active'"
                    [active]="currentWITab === WholesalerIntegrationActivityEnum.Active"
            >
              <app-wholesaler-integration-table *ngIf="wholesalerIntegrationActiveList.length"
                                                (editWholesaler)="openWholesalerIntegrationDialog($event)"
                                                [wholesalerIntegrationList]="wholesalerIntegrationActiveList"
              ></app-wholesaler-integration-table>
            </app-tab>

            <app-tab [tabValue]="WholesalerIntegrationActivityEnum.Inactive"
                    [count]="wholesalerIntegrationInactiveList?.length"
                    [tabTitle]="'Inactive'"
                    [active]="currentWITab === WholesalerIntegrationActivityEnum.Inactive"
            >
              <app-wholesaler-integration-table *ngIf="wholesalerIntegrationInactiveList.length"
                                                (editWholesaler)="openWholesalerIntegrationDialog($event)"
                                                [wholesalerIntegrationList]="wholesalerIntegrationInactiveList"
              ></app-wholesaler-integration-table>
            </app-tab>
          </app-tabs>
        </div>
      </div>
      <!-- PMS -->
      <div class="settings-item pms-integration" *ngIf="isNotBasicPlan">
        <div class="heading-wrapper">
          <div class="description">
            <div class="settings-header">
              <img *ngIf="currentPharmacyManagementSystemIntegrationStatus === PharmacyManagementSystemIntegrationStatusEnum.Created"
                  src="assets/icons/icon-alert-success-blue.svg" alt="success-icon" class="icon-created"
              />
              <img *ngIf="currentPharmacyManagementSystemIntegrationStatus === PharmacyManagementSystemIntegrationStatusEnum.Invalid"
                  src="assets/icons/icon-danger-red.svg" alt="success-icon" class="icon-error"
              />
              <div class="with-label">
                Pharmacy Management System Integration
                <app-badge [color]="BadgeColorsEnum.Green">beta</app-badge>
              </div>
              <div class="settings-sub-header">
                Streamline your workflow by connecting C2 Keep with your pharmacy management system.
              </div>
            </div>

          </div>
          <div class="controls">
            <app-button styleClass="settings"
                        subStyle="blue"
                        [disabled]="setupDisabled || (pmsIntegrations$ | async)?.length === 2"
                        [minWidth]="0"
                        (clicked)="openPharmacyManagementSystemIntegrationDialog()"
            >
            Setup
            </app-button>
          </div>
        </div>

        <div *ngIf="(pmsIntegrations$ | async)?.length && showPharmacyManagementSystemList" class="list-wrapper">
          <app-pms-integration-table
            (activeChanged)="openSecondStepDialog($event)"
            (edit)="openPharmacyManagementSystemIntegrationDialog()"
          ></app-pms-integration-table>
        </div>
      </div>

      <div *ngIf="pharmacyManagementRoles.includes((currentPharmacy$ | async)?.role)" class="settings-item manage-pharmacy">
        <div class="heading-wrapper">
          <div class="description">
            <div class="settings-header">
              Add a Pharmacy
            </div>
            <div class="settings-sub-header">
              Use C2 Keep for each pharmacy you manage.
            </div>
          </div>

          <div *ngIf="!(pharmacies$ | async)?.length" class="controls">
            <app-button text="Add Pharmacy"
                        styleClass="settings"
                        subStyle="blue"
                        [minWidth]="0"
                        (clicked)="openAddPharmacyDialog()"
            >
            </app-button>
          </div>

          <div *ngIf="(pharmacies$ | async)?.length" class="controls">
            <app-button text="Add New"
                        styleClass="settings"
                        subStyle="blue"
                        class="add-new"
                        [minWidth]="0"
                        (clicked)="openAddPharmacyDialog()"
            >
            </app-button>
          </div>
        </div>

        <div *ngIf="(pharmacies$ | async)?.length" class="list-wrapper">
          <div *ngFor="let pharmacy of (pharmacies$ | async); let i = index" class="list-item">
            <div class="name">
              {{pharmacy.name}}
              <div class="address">
                {{pharmacy.address}}
              </div>
            </div>

            <div class="controls">
              <app-button customClasses="px-4"
                          [minWidth]="0"
                          class="edit"
                          text="Edit"
                          subStyle="white"
                          (clicked)="openEditPharmacyDialog(pharmacy.id)"
              >
              </app-button>
            </div>
          </div>
        </div>
      </div>

      <!-- C2-616 - disable this feature for now -->
      <div *ngIf="false && (currentPharmacy$ | async)?.role !== UserRolesEnum.PharmacyAdmin" class="settings-item">
        <div class="description">
          <div class="settings-header">
            Close Account
          </div>
          <div class="settings-sub-header">
            Once your account is closed your data will no longer be accessible.
          </div>
        </div>

        <div class="controls">
          <app-button text="Close Account"
                      styleClass="settings"
                      subStyle="red"
                      class="add-new"
                      [minWidth]="0"
                      (clicked)="openCloseAccountDialog()"
          >
          </app-button>
        </div>
      </div>


      <!-- RUNNING WHOLESALER MESSAGE RESULTS -->
      <app-wholesaler-result-message></app-wholesaler-result-message>
    </div>
  </div>
</div>

<!-- EDIT PROFILE DIALOG -->
<app-edit-profile-dialog *ngIf="showEditProfileDialog"
                         [show]="showEditProfileDialog"
                         (cancel)="closeEditProfileDialog()"
                         (afterSaved)="afterEditProfile($event)"
></app-edit-profile-dialog>

<!-- PHARMACY MANAGEMENT SYSTEM DIALOG -->
<app-dialog-progress *ngIf="showPharmacyManagementSystemIntegrationDialog"
                     [show]="showPharmacyManagementSystemIntegrationDialog"
                     [progress]="currentPharmacyManagementSystemIntegrationProgress"
                     [labels]="pharmacyManagementSystemIntegrationLabels"
                     [progressTitle]="'Your Progress'"
  >
  <app-pms-integration-dialog *ngIf="showPharmacyManagementSystemIntegrationDialog"
                                     [show]="showPharmacyManagementSystemIntegrationDialog"
                                     [progress]="currentPharmacyManagementSystemIntegrationProgress"
                                     [selectedPmsType]="selectedPharmacyManagementSystemIntegration"
                                     (integrationTypeSelected)="setStepperLabels($event)"
                                     (cancel)="closePharmacyManagementSystemIntegrationDialog()"
                                     (nextStep)="setNextPmsStep($event)"
                                     (save)="closePharmacyManagementSystemIntegrationDialog()"
  ></app-pms-integration-dialog>
</app-dialog-progress>

<!-- WHOLESALER INTEGRATION DIALOG -->
<app-dialog-progress *ngIf="showWholesalerIntegrationDialog"
                     [show]="showWholesalerIntegrationDialog"
                     [progress]="currentWholesalerIntegrationProgress"
                     [labels]="wholesalerIntegrationLabels"
                     [progressTitle]="'Your Progress'"
>
  <app-wholesaler-integration-dialog *ngIf="showWholesalerIntegrationDialog"
                                     [show]="showWholesalerIntegrationDialog"
                                     [wholesalerIntegration]="currentWholesaler"
                                     [progress]="currentWholesalerIntegrationProgress"
                                     (cancel)="closeWholesalerIntegrationDialog()"
                                     (nextStep)="setNextStep($event)"
                                     (save)="saveWholesalerIntegration($event)"
  ></app-wholesaler-integration-dialog>
</app-dialog-progress>

<!-- ADD PHARMACY DETAILS DIALOG -->
<app-dialog-progress
  [show]="showCreatePharmacyDialog"
  [progress]="createPharmacyProgress"
  [labels]="createPharmacyProgressLabels"
>
  <app-pharmacy-details
    [currentStep]="createPharmacyProgress"
    (closeForm)="closeCreatePharmacy()"
    [location]="PharmacyLocationEnum.Settings"
    (submitted)="savePharmacyDetails($event)"
    (stepChanged)="setCreatePharmacyStep($event)"
  ></app-pharmacy-details>
</app-dialog-progress>

<!-- EDIT PHARMACY DETAILS DIALOG -->
<app-edit-pharmacy-dialog *ngIf="showEditPharmacyDetails"
                          [show]="showEditPharmacyDetails"
                          [pharmacyId]="currentPharmacyId"
                          (closeEditPharmacyDialog)="closeEditPharmacy()"
                          (saveEditPharmacyDialog)="editPharmacyDetails($event)"
></app-edit-pharmacy-dialog>

<!-- CLOSE ACCOUNT DIALOG -->
<app-warning-dialog [show]="showCloseAccountDialog"
                    header="Are you sure you want to do this?"
                    description="You will have 30 days to export your data from C2 Keep after closing your account."
                    acceptBtnText="Yes, close my account"
                    (cancel)="closeCloseAccountDialog()"
                    (next)="closeAccount()"
></app-warning-dialog>
